interface Props {
  pageSizeOptions: number[];
  onPageSizeChange: (size: number) => void;
}

const DataTablePageSize: React.FC<Props> = ({ pageSizeOptions, onPageSizeChange }) => (
  <div className="flex items-center gap-4">
    <div className="flex items-center font-medium">
      <div className="relative">
        <select
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="text-gray-700 appearance-none rounded-md border-[1.5px] border-stroke bg-white px-5 py-2.5 pl-4 pr-10 outline-none focus:border-primary dark:border-strokedark dark:bg-meta-4 dark:focus:border-primary"
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size} className="text-black">
              {size}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-0 left-auto right-4 flex items-center">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.0002 12.8249C8.83145 12.8249 8.69082 12.7687 8.5502 12.6562L2.08145 6.2999C1.82832 6.04678 1.82832 5.65303 2.08145 5.3999C2.33457 5.14678 2.72832 5.14678 2.98145 5.3999L9.0002 11.278L15.0189 5.34365C15.2721 5.09053 15.6658 5.09053 15.9189 5.34365C16.1721 5.59678 16.1721 5.99053 15.9189 6.24365L9.45019 12.5999C9.30957 12.7405 9.16895 12.8249 9.0002 12.8249Z"
              fill="#64748B"
            />
          </svg>
        </div>
      </div>
      <p className="pl-2 text-gray-700 dark:text-white">Entradas por página</p>
    </div>
  </div>
);

export default DataTablePageSize;
